import { useEffect, useState } from 'react';
import { supabase } from '../auth/supabaseClient';
import { useHistory } from 'react-router-dom';
import { safeReturnTo } from '../auth/returnTo';

const AuthCallback = () => {
  const history = useHistory();
  const returnTo = safeReturnTo(new URLSearchParams(window.location.search).get('returnTo'));
  const [message, setMessage] = useState('Completing sign in...');
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    let mounted = true;
    const run = async () => {
      try {
        const query = new URLSearchParams(window.location.search);
        const hash = new URLSearchParams(window.location.hash.slice(1));
        if (['error', 'error_code', 'error_description'].some((key) => query.has(key) || hash.has(key))) {
          throw new Error('Invalid callback');
        }
        // detectSessionInUrl owns implicit parsing and PKCE exchange. initialize()
        // is cached by Supabase and exposes redirect errors without a second exchange.
        const { error: initializationError } = await supabase.auth.initialize();
        if (initializationError) throw initializationError;
        // A code without a local PKCE verifier can be ignored by the SDK. Do not
        // mistake an older stored session for successful completion of that link.
        if (new URLSearchParams(window.location.search).has('code')) {
          throw new Error('Unprocessed authorization code');
        }
        const { data, error } = await supabase.auth.getSession();
        if (error) throw error;
        if (!mounted) return;
        if (data.session?.access_token && data.session?.user) {
          history.replace(returnTo);
          return;
        }
        setMessage('No sign-in session was found. Please sign in or request a new confirmation link.');
        setIsComplete(true);
      } catch (err) {
        if (!mounted) return;
        setMessage('Sign in failed. This link may be invalid or expired. Please sign in or request a new confirmation link.');
        setIsComplete(true);
      }
    };
    run();
    return () => { mounted = false; };
  }, [returnTo, history]);

  return (
    <div className="login">
      <h2>Signing you in</h2>
      <p>{message}</p>
      {isComplete && (
        <p>
          <a href={`/login?returnTo=${encodeURIComponent(returnTo)}`}>Go to sign in</a>
        </p>
      )}
    </div>
  );
};

export default AuthCallback;
